import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { akitaConfig, persistState } from '@datorama/akita';
import { throttleTime } from 'rxjs';

if (environment.production) {
  enableProdMode();
}

// AG Grid - Enterprise version.
LicenseManager.setLicenseKey(environment.licenses.agGrid);

// Akita - Persists the stores upon page refresh.
const storage = persistState({
  preStorageUpdateOperator: () => throttleTime(1000, undefined, { leading: true, trailing: true }),
});
const providers = [{ provide: 'persistStorage', useValue: storage }];

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule, {
    defaultEncapsulation: ViewEncapsulation.Emulated,
  })
  .then(() => {
    akitaConfig({ resettable: true });
  })
  .catch((err) => {
    // eslint-disable-next-line
    console.error(err);
  });
